import React, {useState} from "react";
import {Alert, Button, FormControl, Modal, ModalTitle, Spinner, Table} from "react-bootstrap";
import {BsChevronLeft, BsChevronRight, BsLink45Deg} from "react-icons/bs";

const PAGE_SIZE = 10;

const LinkOpticianDialog = ({
                                linkableOpticians,
                                linkError,
                                onCancelClicked,
                                onLinkClicked,
                                isLoading,
                            }) => {
    const [filter, setFilter] = useState('');
    const [selectedId, setSelectedId] = useState(null);
    const [page, setPage] = useState(0);

    const filtered = (linkableOpticians || []).filter(o => {
        const q = filter.toLowerCase();
        return o.name?.toLowerCase().includes(q) ||
            o.city?.toLowerCase().includes(q) ||
            o.hsaId?.toLowerCase().includes(q) ||
            o.streetAddress?.toLowerCase().includes(q);
    });

    const totalPages = Math.ceil(filtered.length / PAGE_SIZE);
    const paged = filtered.slice(page * PAGE_SIZE, (page + 1) * PAGE_SIZE);
    const dataLoading = isLoading && (!linkableOpticians || linkableOpticians.length === 0);

    const handleFilterChange = (e) => {
        setFilter(e.target.value);
        setPage(0);
    };

    return (
        <Modal show={true} onHide={onCancelClicked} backdrop="static" keyboard={true} size="lg">
            <div className="SaveOpticianDialog">
                <Modal.Header closeButton>
                    <ModalTitle>
                        <h3 className="mb-0">Koppla befintlig optiker</h3>
                    </ModalTitle>
                </Modal.Header>
                <Modal.Body>
                    <div className="SaveOpticianForm">
                        <FormControl
                            type="text"
                            placeholder="Sök på namn, stad, adress eller HSA-id..."
                            value={filter}
                            onChange={handleFilterChange}
                            className="mb-3"
                            autoFocus
                        />
                    </div>

                    {dataLoading && (
                        <div className="text-center py-3">
                            <Spinner animation="border" />
                        </div>
                    )}

                    {!dataLoading && filtered.length === 0 && (
                        <p className="text-muted">Inga optiker hittades.</p>
                    )}

                    {!dataLoading && filtered.length > 0 && (
                        <>
                            <p className="text-muted small mb-1">
                                {filtered.length} {filtered.length === 1 ? 'optiker' : 'optiker'} hittade
                            </p>
                            <Table size="sm" hover responsive>
                                <thead>
                                <tr>
                                    <th>Namn</th>
                                    <th>Adress</th>
                                    <th>Stad</th>
                                    <th>HSA-id</th>
                                </tr>
                                </thead>
                                <tbody>
                                {paged.map(o => (
                                    <tr
                                        key={o.organizationId}
                                        onClick={() => setSelectedId(o.organizationId)}
                                        className={selectedId === o.organizationId ? 'table-primary' : ''}
                                        style={{cursor: 'pointer'}}
                                    >
                                        <td>{o.name}</td>
                                        <td>{o.streetAddress}</td>
                                        <td>{o.city}</td>
                                        <td>{o.hsaId}</td>
                                    </tr>
                                ))}
                                </tbody>
                            </Table>

                            {totalPages > 1 && (
                                <div className="d-flex justify-content-center align-items-center gap-3 mb-2">
                                    <Button
                                        variant="outline-secondary"
                                        size="sm"
                                        disabled={page === 0}
                                        onClick={() => setPage(p => p - 1)}
                                    >
                                        <BsChevronLeft/>
                                    </Button>
                                    <span className="text-muted small">
                                        Sida {page + 1} av {totalPages}
                                    </span>
                                    <Button
                                        variant="outline-secondary"
                                        size="sm"
                                        disabled={page >= totalPages - 1}
                                        onClick={() => setPage(p => p + 1)}
                                    >
                                        <BsChevronRight/>
                                    </Button>
                                </div>
                            )}
                        </>
                    )}

                    {linkError && <Alert variant="danger" className="mt-2">{linkError}</Alert>}

                    <div className="SaveOpticianDialog-footer">
                        <div className="d-flex justify-content-end gap-2">
                            <Button variant="danger" onClick={onCancelClicked} disabled={isLoading}>
                                Avbryt
                            </Button>
                            <Button
                                variant="primary"
                                disabled={!selectedId || isLoading}
                                onClick={() => onLinkClicked(selectedId)}
                            >
                                {isLoading
                                    ? <><Spinner animation="border" size="sm"/> Kopplar...</>
                                    : <><BsLink45Deg style={{marginRight: '6px'}}/>Koppla</>
                                }
                            </Button>
                        </div>
                    </div>
                </Modal.Body>
            </div>
        </Modal>
    );
};
export default LinkOpticianDialog;
